export default {
  priority: 98,
  name: app.translate("routes.home.attendance.device.Device"),
  path: "device",
  permissions: ["TimeAttendanceMenu/DeviceMenu/DeviceListMenu"],
  icon: "deskphone",
  drawer: true,
};


